import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const USDAI_APY_URL = 'https://api.usd.ai/usdai/dashboard/current-apy'
const usdai = 'sUSDai::SUSDAI'

export const usdaiFetcher: YieldFetcher = {
  label: 'USDai',
  fetch: async () => {
    const res = await fetch(USDAI_APY_URL, {
      headers: {
        origin: 'https://app.usd.ai',
        referer: 'https://app.usd.ai/',
      },
    }).then((r) => r.json())
    return { [usdai]: apyToAprPercent(Number(res.result)) }
  },
}
